import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DoneAllIcon from '@material-ui/icons/Add';
import ViewIcon from '@material-ui/icons/RemoveRedEye';
import ReminderIcon from '@material-ui/icons/Email';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import {withStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import axios from 'axios';
import {
    Button,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Modal} from "reactstrap";

import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2'

const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px",
        top: "50%",
        display: "inline-block",
        position: "relative",
        transform: "translateY(-50%)"
    },
    deleteIcon: {
        color: "red"
    },
    doneAllIcon: {
        color: "#006D5B",
        marginTop: "2rem"
    },
    viewIcon: {
        color: "#1fb7c5",
        marginTop: "2rem"
    },
    reminderIcon: {
        color: "#2DCE89",
        marginTop: "2rem"
    }
};

const mapStateToProps = state => ({users: state.users});

class UserToolbarSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: this.props.users,
            modalIsOpen: false,
            marker_code: '',
            marker_code_to_remove: '',
            selected_user:{},
            marker_codes:[],
            modalIsOpenViewMarkerCodes:false,
            generate_marker_badges:false,
            modalIsOpenViewReminder:false
        };

        this.handleChange = this.handleChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleViewCodes = this.toggleViewCodes.bind(this);
        this.assignMarkerCode = this.assignMarkerCode.bind(this);
        this.viewMarkerCodes = this.viewMarkerCodes.bind(this);
        this.getMarkerCodes = this.getMarkerCodes.bind(this);
        this.generateMarkerBadges = this.generateMarkerBadges.bind(this);
        this.removeMarkerCode = this.removeMarkerCode.bind(this);
        this.deleteMarker = this.deleteMarker.bind(this);
        this.toggleSendReminder=this.toggleSendReminder.bind(this);
        this.sendReminder=this.sendReminder.bind(this);
        this.toggleSendReminder=this.toggleSendReminder.bind(this);
        this.toggleViewReminders=this.toggleViewReminders.bind(this);
    }

    componentDidMount() {
        //console.log('check state select custom select', this.props);
        let selected_user = this.state.users[this.props.selectedRows.data[0].dataIndex];  
        //console.log('check props select custom select', selected_user);
        this.setState({selected_user:selected_user});
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    toggle() {
        this.setState({
            modalIsOpen: !this.state.modalIsOpen
        });
    }

     deleteMarker(){
         let cur = this.state.selected_user.id;
        Swal.fire({
            title: 'Are you sure you want to delete this marker?',
            showCancelButton: true,
            confirmButtonColor:'green',
            confirmButtonText: `Yes, Delete`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                axios({
                    headers: {
                        'content-type': 'application/json',
                        'authorization': 'Bearer ' + localStorage.getItem('access_token')
                    },
                    method: 'get',
                    url: 'https://markerportalbackend.thinkdigitalacademy.org/api/delete-user/'+cur,
                }).then(res => {           
                    Swal.fire('Deleted!', '', 'success');
                    window.location.reload();
                }).catch(error => {
                    // let error_result = error.response;
                    Swal.fire('An error occurred!', '', 'error');
                });
              
            } 
          });
    }

    sendReminder(){
        let selected_users = this.props.selectedRows.data;  
        let users = this.state.users;
        let temp=selected_users.map(function(data){
            return users[data.dataIndex].email;
        });
        let data = {
            users:temp
        }
        console.log('selected_users',temp);
        Swal.fire({
            title: 'Are you sure you want to send marking reminder to the selected marker(s)?',
            showCancelButton: true,
            confirmButtonColor:'green',
            confirmButtonText: `Yes, Send`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                axios({
                    headers: {
                        'content-type': 'application/json',
                        'authorization': 'Bearer ' + localStorage.getItem('access_token')
                    },
                    method: 'post',
                    data:data,
                    url: 'https://admin.thinkdigitalacademy.org/api/send-marker-reminder',

                }).then(res => {           
                    Swal.fire('Reminder sent!', '', 'success');
                    window.location.reload();
                }).catch(error => {
                    // let error_result = error.response;
                    Swal.fire('An error occurred!', '', 'error');
                });
              
            } 
          });
    }

    toggleViewCodes() {
        this.setState({
            modalIsOpenViewMarkerCodes: !this.state.modalIsOpenViewMarkerCodes
        });
    }

    toggleViewReminders() {
        this.setState({
            modalIsOpenViewReminder: !this.state.modalIsOpenViewReminder
        });
    }

    assignMarkerCode() {
        //console.log('assigning marker code: ', this.state);
        let cur = this;
        let data = {
            user_id:this.state.selected_user.id,
            marker_code:this.state.marker_code
        }
        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'post',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/assign-marker-code',
            data: data
        }).then(res => {
            //console.log(res);
            console.log(res.data);
            console.log('assgned marker', res.data);
            cur.setState({modalIsOpen: false,marker_code:''});
           
            toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });

        }).catch(error => {
            let error_result = error.response;
            //console.log(error_result);
            toast('Error occurred. ' + error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    removeMarkerCode() {
        //console.log('removing marker code: ', this.state);
        let cur = this;
        let data = {
            user_id:cur.state.selected_user.id,
            marker_code:cur.state.marker_code_to_remove
        }
        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'post',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/remove-marker-code',
            data: data
        }).then(res => {
            //console.log(res);
            //console.log(res.data);
            //console.log('assgned marker', res.data);
            cur.setState({modalIsOpen: false,marker_code_to_remove:'',marker_codes:res.data.marker_codes});
           
            toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });

        }).catch(error => {
            let error_result = error.response;
            //console.log(error_result);
            toast('Error occurred. ' + error_result, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    handleClick = () => {
        //console.log("click! current selected rows", this.props.selectedRows);
        let selected_user = this.state.users[this.props.selectedRows.data[0].dataIndex];
        //console.log('selected_user', selected_user);
        this.setState({modalIsOpen: true,selected_user:selected_user});      

    };

    viewMarkerCodes(){
        //console.log("click! current selected rows", this.props.selectedRows);
        let selected_user = this.state.users[this.props.selectedRows.data[0].dataIndex];       
        //console.log('selected_user toolbar', selected_user);       
        this.setState({modalIsOpenViewMarkerCodes: true,selected_user:selected_user,generate_marker_badges:true});  
        this.getMarkerCodes(selected_user.id);    

    };

    toggleSendReminder(){
        //console.log("click! current selected rows", this.props.selectedRows);
        let selected_user = this.state.users[this.props.selectedRows.data[0].dataIndex];       
        console.log('selected_user toolbar', selected_user);

        this.setState({modalIsOpenViewReminder: true,selected_user:selected_user});     

    };

    getMarkerCodes(id){
        let user_id = localStorage.getItem('user_id');
        let token = localStorage.getItem('access_token');
            axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-user-marker-codes/'+id, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                console.log('marker codes', res.data);
                this.setState({marker_codes: res.data.marker_codes,generate_marker_badges:true});                                         
    
            }).catch(error => {
                //console.log('error', error);
                toast('An error occurred getting marker codes.'+error, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  type: toast.TYPE.ERROR
              });
            });
      }

      generateMarkerBadges(){
          
        return this.state.marker_codes.map((prop, key) => {
            //console.log('generating badges',prop);
            return(
                <Col lg={1} key={key}>                   
                    <span key={key} className="badge badge-info">{prop}</span>
                </Col>
            );
        });
      }

    render() {
        const {classes} = this.props;

        return (
            <>
                <div className={"custom-toolbar-select"}>
                <Tooltip title={"Send Reminder"}>
                        <IconButton className={
                                classes.iconButton
                            }
                            onClick={
                                this.sendReminder
                        }>
                            <ReminderIcon className={
                                classes.reminderIcon
                            }/>
                        </IconButton>
                    </Tooltip>

                <Tooltip title={"View Marker Codes"}>
                        <IconButton className={
                                classes.iconButton
                            }
                            onClick={
                                this.viewMarkerCodes
                        }>
                            <ViewIcon className={
                                classes.viewIcon
                            }/>
                        </IconButton>
                    </Tooltip>
                    
                    <Tooltip title={"Assign Marker Codes"}>
                        <IconButton className={
                                classes.iconButton
                            }
                            onClick={
                                this.handleClick
                        }>
                            <DoneAllIcon className={
                                classes.doneAllIcon
                            }/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Delete Marker"}>
                        <IconButton className={
                                classes.iconButton
                            }
                            onClick={
                                this.deleteMarker
                        }>
                            <DeleteIcon className={
                                classes.deleteIcon
                            }/>
                        </IconButton>
                    </Tooltip>
                </div>
                <Modal className="modal-dialog-centered"
                    isOpen={
                        this.state.modalIsOpen
                    }
                    toggle={
                        this.toggle
                    }
                    size='sm'>
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Assign Marker Code to: {this.state.selected_user.name + ' '+ this.state.selected_user.surname}
                        </h5>
                        <button aria-label="Close" className="close" data-dismiss="modal" type="button"
                            onClick={
                                this.toggle
                        }>
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Form>
                            <Row>
                                <Col lg="12">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-marker-code">
                                            Marker Code
                                        </label>
                                        <Input name="marker_code" className="form-control-alternative"
                                            value={
                                                this.state.marker_code
                                            }
                                            id="input-marker-code"
                                            placeholder="Enter Marker Code"
                                            type="text"
                                            onChange={
                                                this.handleChange
                                            }/>
                                    </FormGroup>
                                </Col>

                            </Row>

                        </Form>

                    </div>
                    <div className="modal-footer">
                        <Button onClick={
                                this.assignMarkerCode
                            }
                            size="sm"
                            color="success"
                            type="button">
                            Save Marker
                        </Button>
                    </div>
                </Modal>

                <Modal className="modal-dialog-centered"
                    isOpen={
                        this.state.modalIsOpenViewMarkerCodes
                    }
                    toggle={
                        this.toggleViewCodes
                    }
                    size='lg'>
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Marker Codes for : {this.state.selected_user.name + ' '+ this.state.selected_user.surname}
                        </h5>
                        <button aria-label="Close" className="close" data-dismiss="modal" type="button"
                            onClick={
                                this.toggleViewCodes
                        }>
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Form>
                            <Row>
                                { this.state.generate_marker_badges && this.generateMarkerBadges()}
                            </Row>
                            <br/>
                            <hr/>
                            <h4>Enter Code to remove for marker: </h4>
                            <Row>                                
                                <Col lg="6">
                                    <FormGroup>
                                        
                                        <Input name="marker_code_to_remove" className="form-control-alternative"
                                            value={
                                                this.state.marker_code_to_remove
                                            }
                                            id="input-marker-code-to-remove"
                                            placeholder="Enter Marker Code to remove"
                                            type="text"
                                            onChange={
                                                this.handleChange
                                            }/>
                                    </FormGroup>
                                    </Col>
                                    <Col lg={4}>
                                    <Button onClick={
                                            this.removeMarkerCode
                                        }
                                        size="sm"
                                        color="danger"
                                        type="button">
                                        Remove
                                    </Button>
                                    </Col>
                            </Row>

                        </Form>

                    </div>
                    <div className="modal-footer">
                       
                    </div>
                </Modal>
                
            </>

        );
    }
}
export default connect(mapStateToProps)(withStyles(defaultToolbarSelectStyles)(UserToolbarSelect));
